import { Injectable } from '@angular/core';
import { TableService } from '../table.service';
import { Observable } from 'rxjs';
import { EventsCalendarStore } from './events-calendar.store';

@Injectable({
    providedIn: 'root'
})
export class EventsCalendarService {

    constructor(
        private tableService: TableService,
        private store: EventsCalendarStore) {
    }

      get(date: Date) {
        return new Observable(observer => {
            this.tableService.getCalendarioEventiRecords(date).subscribe(
                (res) => {
                    this.store.records = res;
                    observer.next(true);
                },
                err => observer.error(err)
            );
        });
    }

    getPrivate(date: Date) {
        return new Observable(observer => {
            this.tableService.getCalendarioEventiPrivatiRecords().subscribe(
                (res) => {
                    this.store.privateRecords = res;
                    observer.next(true);
                },
                err => observer.error(err)
            );
        });
    }

}
